import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface ProviderAttestationStatusResponse {
  cutoff_date: string;
  doctor_created_date: string | null;
  is_required: boolean;
  is_completed: boolean;
  date_completed: string | null;
}

interface UpdateProviderAttestationPayload {
  is_completed: boolean;
  date_completed: string | null;
}

export const providerAttestationKeys = {
  all: ["providerAttestation"] as const,
};

export function useProviderAttestationStatus(enabled = true) {
  return useQuery({
    queryKey: providerAttestationKeys.all,
    queryFn: async () => api.get<ProviderAttestationStatusResponse>("/dashboard/provider-attestation"),
    enabled,
    staleTime: 0,
  });
}

export function useUpdateProviderAttestation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateProviderAttestationPayload) =>
      api.put("/dashboard/provider-attestation", payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: providerAttestationKeys.all });
    },
  });
}

